// extracted by mini-css-extract-plugin
export var standaloneTable = "_h6-0";
export var standaloneTableWithBodyFill = "_h6-1";
export var withExtraHeader = "_h6-2";